/**
 * Russian translations for UAE property amenity labels.
 * Source vocabulary: PropertyFinder Enterprise API (~30 fixed terms).
 *
 * Unknown terms (added by future API updates) automatically fall back
 * to the original English string — no action required.
 *
 * @type {Record<string, string>}
 */
const propertyAmenitiesRu = {
  "Balcony":             "Балкон",
  "Barbecue Area":       "Зона барбекю",
  "Built In Wardrobes":  "Встроенные шкафы",
  "Central Ac":          "Центральный кондиционер",
  "Childrens Play Area": "Детская площадка",
  "Childrens Pool":      "Детский бассейн",
  "Concierge":           "Консьерж",
  "Conference Room":     "Конференц-зал",
  "Covered Parking":     "Крытая парковка",
  "Kitchen Appliances":  "Кухонная техника",
  "Lobby In Building":   "Лобби в здании",
  "Maid Service":        "Служба уборки",
  "Maids Room":          "Комната для прислуги",
  "Networked":           "Сетевое подключение",
  "Pets Allowed":        "Можно с животными",
  "Private Garden":      "Частный сад",
  "Private Gym":         "Частный спортзал",
  "Private Jacuzzi":     "Частное джакузи",
  "Private Pool":        "Частный бассейн",
  "Security":            "Охрана",
  "Shared Gym":          "Общий спортзал",
  "Shared Pool":         "Общий бассейн",
  "Shared Spa":          "Общий СПА",
  "Study":               "Кабинет",
  "Vastu Compliant":     "По принципам Васту",
  "View Of Landmark":    "Вид на достопримечательность",
  "View Of Water":       "Вид на воду",
  "Walk In Closet":      "Гардеробная",
};

export default propertyAmenitiesRu;
